import {
    BODY_MD_MD_BOLD_STYLES,
    BODY_SM_SM_BOLD_STYLES,
    BODY_SM_SM_MEDIUM_STYLES,
    HEADING_SM_STYLES,
} from '@constants/text.ts';
import type { AttemptLogStatus } from '@routes/sidebar/learning/___pages___/learning-overview/ui/overview/task/constants.ts';
import { LOG_HEADER_BACKGROUND_MAPPER } from '@routes/sidebar/learning/___pages___/learning-overview/ui/overview/task/constants.ts';
import styled from 'styled-components';

export const PrintEvaluationLogWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 210mm; // A4 page width; physical units are standard for print layouts
    max-width: 100%;
    min-height: 297mm;
    margin: 0 auto;
    box-sizing: border-box;
    background: var(--colors-surface-primary, #fff);

    /* Apply print-specific styles only when printing */
    @media print {
        width: 100%;
        max-width: none;
        min-height: auto;
        margin: 0;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md, 24px);
    padding: var(--spacing-md, 24px);
    background: var(--neutral-150, #f1f4f8);
`;

export const Title = styled.div`
    text-align: center;
    color: var(--colors-text-headings, #3e445c);
    ${HEADING_SM_STYLES};
`;

export const LearnerInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2xs, 4px);
`;

export const LearnerName = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_MD_MD_BOLD_STYLES};
`;

export const HeaderText = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_MEDIUM_STYLES};
`;

export const HeaderTextBold = styled.span`
    ${BODY_SM_SM_BOLD_STYLES};
`;

export const TaskInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2xs, 4px);
    padding: var(--spacing-sm, 16px) var(--spacing-md, 24px);
`;

export const Log = styled.div<{ $pageBreakAfter?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm, 16px);

    ${({ $pageBreakAfter }) =>
        $pageBreakAfter &&
        `
        /* Force the next log entry onto a new page when printing */
        @media print {
            break-after: page;
            page-break-after: always;
        }
    `}
`;

export const LogsWrapper = styled.div`
    border-radius: 8px 8px 0 0;
    border: var(--border-width-sm_1, 1px) solid var(--colors-border-primary, #e2e8f0);
    overflow: hidden;
`;

export const LogHeader = styled.div<{ $status?: AttemptLogStatus }>`
    display: flex;
    padding: var(--spacing-sm, 16px) var(--spacing-md, 24px);
    background: ${({ $status }) => ($status ? LOG_HEADER_BACKGROUND_MAPPER[$status] : undefined) ?? 'transparent'};
`;

export const LogContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md, 24px);
    padding: var(--spacing-md, 24px);
`;

export const PrintTaskWrapper = styled.div`
    break-inside: avoid;
    page-break-inside: avoid;
`;

export const PrintSectionWrapper = styled.div`
    break-inside: avoid;
    page-break-inside: avoid;
`;

export const EvidenceContent = styled.div`
    padding: 12px 16px;
    border-radius: var(--border-radius-s_8, 8px);
    border: 1px solid var(--colors-border-primary, #e2e8f0);
    background: var(--neutral-100, #f9fafb);
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_MEDIUM_STYLES};
`;

export const EmptyMessage = styled.div`
    padding: var(--spacing-md, 24px);
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_MEDIUM_STYLES};
`;
